import { render, staticRenderFns } from "./InvestorCustomer.vue?vue&type=template&id=17f811a7&scoped=true&"
import script from "./InvestorCustomer.vue?vue&type=script&lang=js&"
export * from "./InvestorCustomer.vue?vue&type=script&lang=js&"
import style0 from "./InvestorCustomer.vue?vue&type=style&index=0&id=17f811a7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f811a7",
  null
  
)

export default component.exports